package ru.chm.gradereport.ui.screens.reviewers

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Checkbox
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import ru.chm.gradereport.ui.theme.GradeTheme
import androidx.compose.ui.unit.dp
import ru.chm.gradereport.model.CourseDto
import ru.chm.gradereport.model.ReviewerDto
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.AppTextField
import ru.chm.gradereport.ui.components.MutedText
import ru.chm.gradereport.ui.components.PrimaryButton
import ru.chm.gradereport.ui.components.SecondaryButton
import ru.chm.gradereport.ui.components.SoftDeleteButton

@Composable
internal fun ReviewerCard(
    reviewer: ReviewerDto,
    courses: List<CourseDto>,
    isAssigning: Boolean,
    selectedCourses: Set<String>,
    onSelectedCoursesChange: (Set<String>) -> Unit,
    onStartAssign: () -> Unit,
    onCancelAssign: () -> Unit,
    onSaveAssign: () -> Unit,
    isResettingPassword: Boolean,
    newPassword: String,
    onNewPasswordChange: (String) -> Unit,
    onStartResetPassword: () -> Unit,
    onCancelResetPassword: () -> Unit,
    onSaveResetPassword: () -> Unit,
    onDelete: () -> Unit,
) {
    val colors = GradeTheme.colors
    AppCard(modifier = Modifier.fillMaxWidth().padding(bottom = 12.dp)) {
        Text(reviewer.displayName, color = colors.textPrimary, fontWeight = FontWeight.Bold)
        MutedText("UID: ${reviewer.uid}")
        MutedText("Логин: ${reviewer.login}")
        MutedText(
            if (reviewer.courseNames.isEmpty()) "Курсы не назначены"
            else "Курсы: ${reviewer.courseNames.joinToString()}",
        )
        Row(
            modifier = Modifier.padding(top = 12.dp),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            PrimaryButton("Назначить курсы", onClick = onStartAssign)
            SecondaryButton("Сменить пароль", onClick = onStartResetPassword)
            SoftDeleteButton(text = "Удалить", onClick = onDelete)
        }

        if (isResettingPassword) {
            Column(modifier = Modifier.padding(top = 12.dp)) {
                MutedText("Новый пароль для ${reviewer.displayName}:")
                AppTextField(
                    newPassword,
                    onNewPasswordChange,
                    "Новый пароль",
                    modifier = Modifier.padding(top = 8.dp),
                )
                Row(
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.padding(top = 8.dp),
                ) {
                    PrimaryButton(
                        "Сохранить пароль",
                        enabled = newPassword.isNotBlank(),
                        onClick = onSaveResetPassword,
                    )
                    SecondaryButton("Отмена", onClick = onCancelResetPassword)
                }
            }
        }

        if (isAssigning) {
            Column(modifier = Modifier.padding(top = 12.dp)) {
                MutedText("Отметьте курсы для этого проверяющего:")
                courses.forEach { course ->
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.fillMaxWidth(),
                    ) {
                        Checkbox(
                            checked = course.id in selectedCourses,
                            onCheckedChange = { checked ->
                                onSelectedCoursesChange(
                                    if (checked) selectedCourses + course.id
                                    else selectedCourses - course.id,
                                )
                            },
                        )
                        Text(course.name, color = colors.textPrimary)
                    }
                }
                Row(
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.padding(top = 8.dp),
                ) {
                    PrimaryButton("Сохранить", onClick = onSaveAssign)
                    SecondaryButton("Отмена", onClick = onCancelAssign)
                }
            }
        }
    }
}
